export class PxFusionModel {
	SessionId: string = '';
	CardNumber: string = '';
	CardHolderName: string = '';
	ExpiryMonth: number = undefined!;
	ExpiryYear: number = undefined!;
	Cvc2: number = undefined!;

	constructor(data: Partial<PxFusionModel>) {
		Object.assign(this, data);
	}
}
